import React from "react"
import { inject, observer } from 'mobx-react'
import { NavLink } from "react-router-dom";
import logo from "../../Style/logo.webp";

import Components from "../../Components";

const Nav = ( props ) => {
	return (
		<>

			<Components.Loading show={props.Data.loading ?? props.Auth.loading}/>
			<Components.Error error={props.Data.error}/>

			<nav className="nav">
				<NavLink to="/" className="nav__logo">
					<img src={logo} alt="logo"/>
				</NavLink>
				<div className={"nav__icon"}>
					<NavLink exact className="nav__item" activeClassName='nav__item--is-active' to="/">
						<i className="las la-tasks"></i>
					</NavLink>
					{
						props.Auth.id_user_group != 4 &&
						<>
							<NavLink exact className="nav__item" activeClassName='nav__item--is-active' to="/history">
								<i className="las la-history"></i>
							</NavLink>
							<NavLink exact className="nav__item" activeClassName='nav__item--is-active' to="/point">
								<i className="las la-tools"></i>
							</NavLink>
						</>
					}
					<NavLink exact className="nav__item" activeClassName='nav__item--is-active' to="/logout">
						<i className="las la-sign-out-alt"></i>
					</NavLink>
				</div>
			</nav>

		</>
	)
}

export default inject( 'Data', 'Auth' )( observer( Nav ) )
